@let colorsOptions = filterColorsOptions();
@let implantationOptions = filterImplantationOptions();
@let budgetOptions = filterBudgetOptions();
@let showOrderingFilter = data.showOrderingFilter;
<section [class.pb-2]="showOrderingFilter" [class.py-7]="!showOrderingFilter">
  <div class="centered-with-padding">
    <div class="grid select-none grid-cols-1 py-2.5 desk:grid-cols-[1fr_auto]">
      @let title = data.title;
      @if (title) {
        <app-title
          [class.desk:max-w-[600px]]="showOrderingFilter"
          [class.desk:max-w-[70%]]="!showOrderingFilter"
          [title]="title"
          class="pb-7"
          size="h1" />
      }
      @if (title && !showOrderingFilter) {
        <div></div>
      }
      @if (showOrderingFilter) {
        <div [class.pb-7]="showOrderingFilter" class="flex flex-col gap-y-2 desk:items-end">
          <app-filter-select
            (onFilterSelected)="emitGtmEventWrapper()"
            [dropdownPosition]="breakpoints() === 'mobile' ? 'LEFT' : 'RIGHT'"
            [options]="filterSelectionOptions"
            filterName="filter_selection" />
          @if (!hasFiltersOpen()) {
            <ng-container *ngTemplateOutlet="filterSelectionLayoutTemplate" />
          }
        </div>
      }
      @if (!hasFiltersOpen() && !showOrderingFilter) {
        <ng-container *ngTemplateOutlet="filterSelectionLayoutTemplate" />
      }
      @if (hasFiltersOpen() && colorsOptions && implantationOptions && budgetOptions) {
        <div class="flex flex-col gap-2 pb-2.5 text-[18px] font-medium desk:col-span-2 desk:flex-row">
          @let hasBudgetOptions = budgetOptions.length > 0;
          @if (implantationOptions.length > 0) {
            <div class="flex flex-wrap items-center">
              <span class="inline-block py-2 pr-2">{{
                "COMPONENT.TITRE-FILTRES-MODELES.SEARCH_KITCHEN" | translate
              }}</span>
              <div class="flex-nowrap">
                <app-filter-select
                  (onFilterSelected)="emitGtmEventWrapper()"
                  [options]="implantationOptions"
                  [placeholder]="'COMPONENT.TITRE-FILTRES-MODELES.LAYOUT_PLACEHOLDER' | translate"
                  filterName="filter_layout"
                  theme="COLORED" />
                @if (hasBudgetOptions) {
                  <span class="inline-block p-2">,</span>
                }
              </div>
            </div>
          }
          @if (hasBudgetOptions) {
            <div>
              <app-filter-select
                (onFilterSelected)="emitGtmEventWrapper()"
                [options]="budgetOptions"
                [placeholder]="'COMPONENT.TITRE-FILTRES-MODELES.BUDGET_PLACEHOLDER' | translate"
                filterName="filter_budget"
                theme="COLORED" />
            </div>
          }
          @if (colorsOptions.length > 0) {
            <div>
              <span class="inline-block p-2">{{ "COMPONENT.TITRE-FILTRES-MODELES.PS_LOVE" | translate }}</span>
              <app-filter-select
                (onFilterSelected)="emitGtmEventWrapper()"
                [options]="colorsOptions"
                [placeholder]="'COMPONENT.TITRE-FILTRES-MODELES.KITCHEN_FRONTS_PLACEHOLDER' | translate"
                filterName="filter_front"
                theme="COLORED" />
            </div>
          }
        </div>
        <div
          (click)="resetFilter()"
          [ngClass]="{ hidden: !canViewResetFiltersButton() }"
          class="cursor-pointer underline">
          {{ "COMPONENT.TITRE-FILTRES-MODELES.RESET_FILTERS" | translate }}
        </div>
      }
    </div>
  </div>
</section>
<ng-template #filterSelectionLayoutTemplate>
  <div class="flex w-max items-center gap-x-2.5 rounded-xl bg-anis py-1.5 pl-[14px] pr-[6px]">
    {{ "COMPONENT.TITRE-FILTRES-MODELES.CHOOSE_ACTION" | translate }}
    <span
      (click)="hasFiltersOpen.set(true)"
      class="flex cursor-pointer items-center gap-x-2.5 rounded-xl bg-white p-2.5">
      {{ "COMPONENT.TITRE-FILTRES-MODELES.KITCHEN_LAYOUT" | translate }}
      <app-svg [height]="15" [width]="15" src="assets/icons/caret-right.svg" />
    </span>
  </div>
</ng-template>
